/**
 * Authentication helper utilities for making authenticated API requests
 */

/**
 * Get authorization headers with bearer token from storage
 * @returns {Object} Headers object with Authorization bearer token
 */
export function authHeaders() {
  try {
    const stored =
      window.localStorage.getItem("cm_auth_tokens") ||
      window.sessionStorage.getItem("cm_auth_tokens");

    if (!stored) {
      return {};
    }

    const tokens = JSON.parse(stored);
    const accessToken = tokens?.accessToken || tokens?.token;

    if (!accessToken) {
      return {};
    }

    return {
      Authorization: `Bearer ${accessToken}`,
    };
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Error reading auth headers:", error);
    }
    return {};
  }
}

/**
 * Check if user is authenticated (has valid tokens)
 * @returns {boolean} True if user has authentication tokens
 */
export function isAuthenticated() {
  try {
    const stored =
      window.localStorage.getItem("cm_auth_tokens") ||
      window.sessionStorage.getItem("cm_auth_tokens");

    if (!stored) {
      return false;
    }

    const tokens = JSON.parse(stored);
    return !!(tokens?.accessToken || tokens?.token);
  } catch {
    return false;
  }
}

/**
 * Get the current access token
 * @returns {string|null} Access token or null if not found
 */
export function getAccessToken() {
  try {
    const stored =
      window.localStorage.getItem("cm_auth_tokens") ||
      window.sessionStorage.getItem("cm_auth_tokens");

    if (!stored) {
      return null;
    }

    const tokens = JSON.parse(stored);
    return tokens?.accessToken || tokens?.token || null;
  } catch {
    return null;
  }
}
